/**
 * Shared room grouping for condition walkthrough items — used by the landlord runner and the
 * read-only tenant-checklist modal so both order rooms/items identically.
 */

import type { ConditionItemResponse } from './condition.api';

export interface RoomGroup {
  roomName: string;
  items: ConditionItemResponse[];
}

/** Groups items by room (first-seen order of `displayOrder`), items sorted by `displayOrder`. */
export function groupItemsByRoom(items: ConditionItemResponse[]): RoomGroup[] {
  const byRoom = new Map<string, ConditionItemResponse[]>();
  for (const item of [...items].sort((a, b) => a.displayOrder - b.displayOrder)) {
    const list = byRoom.get(item.roomName) ?? [];
    list.push(item);
    byRoom.set(item.roomName, list);
  }
  return Array.from(byRoom.entries()).map(([roomName, roomItems]) => ({ roomName, items: roomItems }));
}
